import BaseService from "./BaseService";

class CustomFieldService {
  static async list() {
    return await BaseService.callAPI(`/custom-fields`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/custom-fields`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/custom-fields/${id}`);
  }

  static async update({ id, data }) {
    return await BaseService.callAPI(`/custom-fields/${id}`, "POST", data);
  }

  static async delete({ id }) {
    return await BaseService.callAPI(`/custom-fields/${id}`, "DELETE");
  }

  static async deleteSection({ id }) {
    return await BaseService.callAPI(`/custom-fields/section/${id}`, "DELETE");
  }

  static async updateFieldOrder({ id, data }) {
    return await BaseService.callAPI(
      `/custom-fields/order/sections/${id}`,
      "POST",
      data
    );
  }

  static async listSections() {
    return await BaseService.callAPI(`/custom-fields/sections`);
  }

  static async createSection(data) {
    return await BaseService.callAPI(`/custom-fields/sections`, "POST", data);
  }

  static async sectionDetails({ id }) {
    return await BaseService.callAPI(`/custom-fields/sections/${id}`);
  }

  static async updateSection({ id, data }) {
    return await BaseService.callAPI(
      `/custom-fields/sections/${id}`,
      "POST",
      data
    );
  }

  static async updateSectionOrder(data) {
    return await BaseService.callAPI(
      `/custom-fields/sections/order`,
      "POST",
      data
    );
  }
}

export default CustomFieldService;
